<template>
	<button class="nav-right-button" :class="{ 'is-open': open }" type="button">
		<span class="nav-icon" :class="`icon-${icon}`" aria-hidden="true" v-html="icons[icon]" />
		<span class="meet-title-text">{{ label }}</span>
	</button>
</template>
<script setup lang="ts">
import { icons } from '@shared-assets/icons-v2'

/**
 * 頂欄右側按鈕，Share 與 Language 共用（樣式在 NavigationBar 的全域樣式）
 */
defineProps<{
	/**
	 * icon 名稱
	 */
	icon: 'share' | 'globe'
	/**
	 * 按鈕文字
	 */
	label: string
	/**
	 * 開啟中，維持被按住的樣子
	 */
	open?: boolean
}>()
</script>
